<div class="link-contact">
    <a href="https://github.com/Patriciavaldebenito" target="_blank">
        <i class="fab fa-github"></i>
    </a>

<a href="mailto:patricia.vpanes@gmail.com">
    <i class="far fa-envelope"></i>
</a>
    

    <a href="https://www.linkedin.com/in/patricia-valdebenito" target="_blank">
        <i class="fab fa-linkedin"></i>
    </a>


</div>



